// extracted by mini-css-extract-plugin
export default {"logo":"KiqyPJWoyEz_IKTaGz7d","content":"KokG_fIUj8fkY3gqx4Sh","tabs-container":"b22dQHh747MNH2lKdkCS","tabs":"OKNk5FhxJrlV5ICEqc93"};